import ParticleCard from '@qc/particle/lib/components/card'

import styled from 'styled-components';

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
`;

export const QuantcastLogo = styled.div`
  background-position: center;
  background-size: contain;
  background-image: url("https://static.quantcast.com/images/quantcast-logo-black.svg");
  background-repeat: no-repeat;
  height: 26px;
  width: 148px;
  margin-bottom: 30px;
`;

export const ProductContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Card = styled(ParticleCard)`
  background-color: #fff;
  width: 400px;
  padding: 24px 24px 24px;
  
  .particle-card-body {
    padding: 0px;
  }

  @media only screen and (max-height: 750px) {
    margin-top: 10px;
  }

  .simple-card__content {
    padding: 30px 20px 30px 20px;
  }

  .particle-form-item-label {
    padding-bottom: 4px;
  }

  .particle-form-item-label > label {
    color: var(--gray-8);
    font-weight: 600;
  }
  
  .particle-alert {
    margin-bottom: 10px;
  }
`;

export const CardLarge = styled(Card)`
  width: 1376px;
  margin: 24px 0px 24px;
`;

export const H3 = styled.h3`
    margin-top: 0px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #5e5e5e;
    font-size: 20px;
`;
